module.exports = __webpack_public_path__ + "static/media/48361587_2308813375860507_5458749501588111360_o.6125e666.jpg";